/* Card hover actions: the cart icon triggers the theme's existing quick-add
   (AJAX add for simple products, options modal for variants); sold-out and
   no-form cases fall back to the product page. */
(function () {
  if (window.__cpoCardActions) return;
  window.__cpoCardActions = true;
  document.addEventListener('click', function (e) {
    var view = e.target.closest('[data-cpo-view]');
    var add = e.target.closest('[data-cpo-add]');
    var btn = view || add;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var url = btn.getAttribute('data-url');
    // Sold-out "add to cart" just opens the product page
    if (add && add.hasAttribute('data-soldout')) {
      if (url) window.location = url;
      return;
    }
    // Both quick-view and add-to-cart open the product's quick-view popup
    var card = btn.closest('.card-wrapper') || btn.closest('.card');
    var trigger = card && card.querySelector(
      '.quick-add modal-opener > button, .quick-add product-form button[type="submit"], .quick-add button[type="submit"], .quick-add .quick-add__submit, .quick-add button'
    );
    if (trigger) {
      trigger.click();
    } else if (url) {
      window.location = url;
    }
  }, true);
})();
